import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { hot } from "react-hot-loader";
import { getUsers, setEventDate } from "./actions";
import { Transition, TransitionGroup } from "react-transition-group";
import DragSensorCellRow from "./DragSensorCellRow";
import _ from "lodash";
import moment from "moment";
import {
    selectWeekCount,
    selectRowCount,
    selectEvents,
    selectArrangedJobpostingsAsArray,
    selectClickedEventSegment,
} from "./selectors";

const Container = styled.div`
    grid-row-start: 1;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: ${(props) => props.weekCount * 7 + 1};

    background-color: white;
    display: grid;
    grid-template-columns: ${(props) => props.weekCount * 7}fr;
    grid-template-rows: 1fr;
    position: relative;
`;

const EventRowContainer = styled.div`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: absolute;
`;

const DragSensorCellRowContainer = styled.div`
    top: ${(props) => (100 / props.rowCount) * props.rowIndex}%;
    bottom: ${(props) => 100 - (100 / props.rowCount) * (props.rowIndex + 1)}%;
    position: absolute;
    transition: all ${(props) => props.duration}ms ease-in-out;
    left: 0%;
    right: 0%;
    &.entering {
        opacity: 1;
    }
    &.entered {
        opacity: 1;
    }
    &.exiting {
        opacity: 0;
    }
`;

class DragSensorCells extends React.Component {
    state = {
        draggingCellColumnIndex: false,
        draggingCellRowIndex: false,
    };
    componentDidUpdate(prevProps) {
        if (prevProps.clickedEventSegment !== this.props.clickedEventSegment) {
            if (this.props.clickedEventSegment === false) {
                this.setState({
                    draggingCellColumnIndex: false,
                    draggingCellRowIndex: false,
                });
            }
        }
    }

    onDragOver = (e, columnIndex, rowIndex) => {
        if (
            this.state.draggingCellColumnIndex !== columnIndex ||
            this.state.draggingCellRowIndex !== rowIndex
        ) {
            this.setState(
                {
                    draggingCellColumnIndex: columnIndex,
                    draggingCellRowIndex: rowIndex,
                },
                () => {
                    this.props.setEventDate(
                        this.state.draggingCellColumnIndex,
                        this.state.draggingCellRowIndex
                    );
                }
            );
        }
    };
    isOverlapping(fStart, fEnd, sStart, sEnd) {
        let format = "DD-MM-YYYY";
        if (fStart && fEnd && sStart && sEnd) {
            fStart = moment(fStart, format);
            fEnd = moment(fEnd, format);
            sStart = moment(sStart, format);
            sEnd = moment(sEnd, format);
            if (
                sStart.isBetween(fStart, fEnd, undefined, "[]") ||
                sEnd.isBetween(fStart, fEnd, undefined, "[]") ||
                fStart.isBetween(sStart, sEnd, undefined, "[]") ||
                fEnd.isBetween(sStart, sEnd, undefined, "[]") ||
                (sStart.isBetween(fStart, fEnd, undefined, "[]") &&
                    sEnd.isBetween(fStart, fEnd, undefined, "[]"))
            )
                return true;
            else return false;
        } else return false;
    }
    getRowCount = () => {
        if (this.props.arrangedJobpostingsAsArray.length > 0) {
            let postings = _.compact(
                this.props.arrangedJobpostingsAsArray.map((e, i) => {
                    if (this.props.events[e.uid])
                        return this.props.events[e.uid].track_id ===
                            this.props.track_id
                            ? e
                            : null;
                    else return null;
                })
            );

            if (postings.length < 1) return 1;
            let obj = {};
            let countArr = postings.map((e) => {
                let fEvent = this.props.events[e.uid];

                let count = 1;
                postings.map((f) => {
                    let sEvent = this.props.events[f.uid];
                    if (
                        e.uid !== f.uid &&
                        this.isOverlapping(
                            fEvent.start_date,
                            fEvent.end_date,
                            sEvent.start_date,
                            sEvent.end_date
                        )
                    ) {
                        let ob = obj[e.uid] || [];
                        ob.push(f.uid);

                        obj = { ...obj, [e.uid]: ob };
                        count++;
                    }
                    return null;
                });
                if (obj[e.uid]) {
                }
                return count;
            });
            let reduced = {};
            let redCount = false;
            Object.keys(obj).map((e) => {
                if (obj[e].length > 1) {
                    reduced = { ...reduced, [e]: obj[e] };
                }
                return null;
            });
            Object.keys(reduced).map((e) => {
                reduced[e].map((r) => {
                    let fEvent = this.props.events[r];
                    reduced[e].map((d) => {
                        let sEvent = this.props.events[d];

                        if (
                            d !== r &&
                            !this.isOverlapping(
                                fEvent.start_date,
                                fEvent.end_date,
                                sEvent.start_date,
                                sEvent.end_date
                            )
                        )
                            redCount = true;

                        return null;
                    });
                    return null;
                });
                return null;
            });
            let rows = Math.max.apply(Math, countArr);

            return redCount ? rows - 1 : rows;
        } else return 0;
    };
    render() {
        let { rowCount, duration } = this.props;
        if (rowCount === 0) {
            rowCount = 1;
        }

        return (
            <Container weekCount={this.props.weekCount}>
                <TransitionGroup component={EventRowContainer}>
                    {this.getRowCount() > 0 &&
                        Array(this.getRowCount())
                            .fill()
                            .map((e, i) => {
                                return (
                                    <Transition key={i} timeout={duration}>
                                        {(transitionStatus) => {
                                            return (
                                                <DragSensorCellRowContainer
                                                    rowIndex={i}
                                                    rowCount={this.getRowCount()}
                                                    duration={duration}
                                                    className={transitionStatus}
                                                >
                                                    <DragSensorCellRow
                                                        transitionStatus={
                                                            transitionStatus
                                                        }
                                                        rowIndex={i}
                                                        duration={duration}
                                                        onDragOver={
                                                            this.onDragOver
                                                        }
                                                    />
                                                </DragSensorCellRowContainer>
                                            );
                                        }}
                                    </Transition>
                                );
                            })}
                </TransitionGroup>
            </Container>
        );
    }
}

export default hot(module)(
    React.memo(
        connect(
            (store) => {
                return {
                    weekCount: selectWeekCount(store),
                    rowCount: selectRowCount(store),
                    arrangedJobpostingsAsArray: selectArrangedJobpostingsAsArray(
                        store
                    ),
                    events: selectEvents(store),
                    clickedEventSegment: selectClickedEventSegment(store),
                };
            },
            { getUsers, setEventDate }
        )(DragSensorCells)
    )
);
